/**
 * Main Layout Component
 * Provides the overall structure with sidebar, header, and main content area
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MainLayout.css';
import Sidebar from './Sidebar';
import Header from './Header';
import ProfileModal from '../Account/ProfileModal';
import PaymentsModal from '../Account/PaymentsModal';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout = ({ children }) => {
  const { theme, toggleTheme } = useTheme();
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [paymentsModalOpen, setPaymentsModalOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="main-layout">
      <Header
        dropdownOpen={dropdownOpen}
        onMenuClick={() => setDropdownOpen((o) => !o)}
        onCloseDropdown={() => setDropdownOpen(false)}
        onProfileClick={() => setProfileModalOpen(true)}
        onPaymentsClick={() => setPaymentsModalOpen(true)}
        onLogoutClick={handleLogout}
        onThemeToggle={toggleTheme}
        theme={theme}
      />

      <div className="main-layout-content">
        <Sidebar
          isOpen={sidebarOpen}
          onToggle={() => setSidebarOpen(!sidebarOpen)}
          mobileOpen={mobileMenuOpen}
          onMobileClose={() => setMobileMenuOpen(false)}
        />

        <main className="main-content">
          {children}
        </main>
      </div>

      <ProfileModal isOpen={profileModalOpen} onClose={() => setProfileModalOpen(false)} />
      <PaymentsModal isOpen={paymentsModalOpen} onClose={() => setPaymentsModalOpen(false)} />
    </div>
  );
};

export default MainLayout;







